import ChevronSVG from '../../assets/imgs/icon/chevron-down-solid.svg';

export type ChevronProps = {
	isActive: boolean;
	color?: 'primary' | 'secondary' | 'inherit';
	noAlign?: boolean;
};

export const Chevron: React.FC<ChevronProps> = ({ isActive }) => {
	const style: React.CSSProperties = {
		width: '14px',
		display: 'block',
		transform: isActive
			? 'rotate3d(1, 0, 0, 180deg) translateY(-1px)'
			: 'rotate3d(1, 0, 0, 0deg) translateY(1px)',
		transition: 'transform 1s ease'
	};

	return (
		<i style={style}>
			<img src={ChevronSVG} />
		</i>
	);
};
